import { render, staticRenderFns } from "./AddEditScaleBasedGroupType.vue?vue&type=template&id=2974edba"
import script from "./AddEditScaleBasedGroupType.vue?vue&type=script&lang=js"
export * from "./AddEditScaleBasedGroupType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports